import LegalLayout, { Section } from "../components/landing/LegalLayout";

export default function Privacidade() {
  return (
    <LegalLayout title="Política de Privacidade" updated="Última atualização: julho de 2026" testid="page-privacidade">
      <Section n="01" title="Dados que coletamos">
        <p>
          Coletamos dados de cadastro (nome, e-mail, telefone), dados de jogo
          (partidas, vitórias, ranking), dados financeiros de carteira
          (depósitos, créditos e trocas por produtos) e, quando exigido por lei, documentos de
          verificação de identidade (KYC).
        </p>
      </Section>
      <Section n="02" title="Como usamos seus dados">
        <p>
          Utilizamos os dados para operar as partidas e a carteira, prevenir
          fraudes, cumprir obrigações legais e regulatórias, processar trocas
          de produtos e melhorar a experiência do aplicativo. E-mails cadastrados na lista VIP
          são usados apenas para comunicações sobre o lançamento.
        </p>
      </Section>
      <Section n="03" title="Base legal e LGPD">
        <p>
          O tratamento de dados segue a Lei Geral de Proteção de Dados (Lei
          nº 13.709/2018), com base no consentimento, na execução de contrato e
          no cumprimento de obrigações legais, conforme cada finalidade.
        </p>
      </Section>
      <Section n="04" title="Compartilhamento">
        <p>
          Compartilhamos dados apenas com provedores essenciais à operação:
          processadores de pagamento, serviços de verificação de identidade e
          ferramentas antifraude — sempre sob contratos de proteção de dados.
          Não vendemos dados pessoais.
        </p>
      </Section>
      <Section n="05" title="Segurança e retenção">
        <p>
          Aplicamos criptografia, controle de acesso e registros de auditoria.
          Registros financeiros e de partidas são mantidos de forma imutável
          pelo período exigido pela legislação aplicável.
        </p>
      </Section>
      <Section n="06" title="Seus direitos">
        <p>
          Você pode solicitar acesso, correção, portabilidade ou exclusão dos
          seus dados pessoais a qualquer momento pelo e-mail
          privacidade@duelo.gg. Solicitações de exclusão podem estar sujeitas a
          retenções legais obrigatórias.
        </p>
      </Section>
    </LegalLayout>
  );
}
